import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'

const getSelectedVariantIdUtil = ({
  productVariantSample,
  sampledData,
  shouldShowFullSizeConversion
}) => {
  const variantId = sampledData?.variantId

  if (!variantId) {
    return
  }

  const variants = getVariantsProductVariantUtil(productVariantSample)
  if (!variants?.length) {
    return
  }

  const correctSampleVariant = variants.find(
    variant => variant.variant_id === variantId
  )

  if (shouldShowFullSizeConversion) {
    return correctSampleVariant?.fullsize_variant_id
  }

  return correctSampleVariant?.variant_id
}

export default getSelectedVariantIdUtil
